export const NEW_CURRENCY = 'NEW_CURRENCY';
export const EDIT_CURRENCY = 'EDIT_CURRENCY';